<template>
  <div v-if="drawComponent && showForm">
    <!-- short view layout -->
    <template v-if="saleLayout">
      <ul class="media-list">
        <li class="media">
          <a @click.prevent="itemViewClick(object.id)" class="media-left">
            <img v-if="object.profile.logo" :src="object.profile.logo.preview" class="img-sm img-circle" alt="">
            <img v-else src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt="">
          </a>
          <div class="media-body">
            <a @click.prevent="itemViewClick(object.id)" class="media-heading text-semibold">{{ object.profile.first_name }} {{ object.profile.last_name }}</a>
            <span class="text-size-mini text-muted display-block">{{ object.email }}</span>
          </div>
        </li>
      </ul>
      <form class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-5 control-label">First Name</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.first_name" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">Last Name</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.last_name" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">Phone</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.phone" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">Address</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.address" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">Zip</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.zip" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">City</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.city" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">State</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.state" class="form-control form-control-small-height"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-5 control-label">Country</label>
          <div class="col-sm-7">
            <input type="text" :readonly="mode.readonly" v-model="object.profile.country" class="form-control form-control-small-height"/>
          </div>
        </div>
      </form>
      <div v-if="allowEdit" class="text-center">
        <a v-if="mode.readonly" href="" @click.prevent="() => { mode.readonly = false }" class="btn btn-primary btn-ladda mt-10">EDIT CLIENT DATA</a>
        <template v-else-if="!mode.readonly">
          <a @click.prevent="saveData()" class="btn btn-primary btn-ladda mt-10 mr-10">SAVE DATA</a>
          <a @click.prevent="() => { mode.readonly = true }" class="btn btn-default btn-ladda mt-10 mr-10">CANCEL</a>
        </template>
      </div>
    </template>
    <!-- /short view layout -->
    <!-- short view layout -->
    <template v-if="shortLayout">
      <ul class="media-list">
        <li class="media">
          <a @click.prevent="itemViewClick(object.id)" class="media-left">
            <img v-if="object.profile.logo" :src="object.profile.logo.preview" class="img-sm img-circle" alt="">
            <img v-else src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt="">
          </a>
          <div class="media-body">
            <a @click.prevent="itemViewClick(object.id)" class="media-heading text-semibold">{{ object.profile.first_name }} {{ object.profile.last_name }}</a>
            <span class="text-size-mini text-muted display-block">{{ object.email }}</span>
          </div>
          <div class="media-right media-middle">
            <span class="status-mark border-success"></span>
          </div>
        </li>
      </ul>
      <div v-if="allowEdit" class="text-center">
        <a href="" @click.prevent="() => {}" class="btn btn-primary btn-ladda mt-10">EDIT CLIENT DATA</a>
      </div>
    </template>
    <!-- /short view layout -->
    <!-- standard form VIEW layout -->
    <template v-if="standardLayout">
      <div :class="{'col-lg-6 col-md-8 col-sm-12': !fullWidth, 'col-sm-12': fullWidth}">
        <panel :title='$formatter.formatUser(object)' :footerShow="false">
          <div class="row">
            <div class="row">
              <div class='col-sm-12'>
                <div class="col-sm-2" style="padding-top: 16px;">
                  <div class="thumbnail" v-if="object.profile.logo">
                    <div class="thumb">
                      <a class="logo-image" :href="object.profile.logo.fullscale" data-popup="lightbox">
                        <img v-if="object.profile.logo.is_public" :src="object.profile.logo.preview" alt="logo"/>
                        <img v-if="!object.profile.logo.is_public" v-auth-img="object.profile.logo.preview" alt="logo"/>
                      </a>
                    </div>
                  </div>
                  <div class="thumbnail" v-else>
                    <div class="thumb">
                      <a class="logo-image">
                        <img :src="require('@/assets/images/placeholder.jpg')" alt="logo"/>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-sm-10">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group" :class="{'has-error': errors.has('location') }">
                        <label class="control-label">First name</label>
                        <span class="form-control">{{object.profile.first_name}}</span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group" :class="{'has-error': errors.has('location') }">
                        <label class="control-label">Last name</label>
                        <span class="form-control">{{object.profile.last_name}}</span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group" :class="{'has-error': errors.has('location') }">
                        <label class="control-label">Agency</label>
                        <br />
                        <span v-if="getAgency().id" class="form-control">{{getAgency().name}}</span>
                        <span v-else class="form-control text-muted"><i>(not set)</i></span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group" :class="{'has-error': errors.has('location') }">
                        <label class="control-label">Email</label>
                        <span class="form-control">{{object.email}}</span>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group" :class="{'has-error': errors.has('location') }">
                        <label class="control-label">Phone</label>
                        <span class="form-control">{{object.profile.phone}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-sm-12'>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Date of Birth</label>
                    <span class="form-control">{{object.profile.dob}}</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Gender</label>
                    <br/>
                    <label class="radio-inline"><input type="radio" disabled name="gender" v-model="object.profile.gender" value="male"/> Male</label>
                    <label class="radio-inline"><input type="radio" disabled name="gender" v-model="object.profile.gender" value="female"/> Female</label>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-sm-12'>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Address</label>
                    <span class="form-control">{{object.profile.address}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-sm-12'>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Country</label>
                    <span class="form-control">{{object.profile.country}}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">State/Province</label>
                    <span class="form-control">{{object.profile.state}}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Postal code</label>
                    <span class="form-control">{{object.profile.zip}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-sm-12'>
              <div class="row">
                <h3 class="panel-title" style="margin-left: -10px; margin-bottom: 15px;">Bank details</h3>
                <div class="col-sm-3">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Bank name</label>
                    <span class="form-control">{{object.profile.bank_name}}</span>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">Bank address</label>
                    <span class="form-control">{{object.profile.bank_address}}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">IBAN</label>
                    <span class="form-control">{{object.profile.bank_iban}}</span>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group" :class="{'has-error': errors.has('location') }">
                    <label class="control-label">BIC</label>
                    <span class="form-control">{{object.profile.bank_bic}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </panel>
      </div>
    </template>
    <!-- /standard form VIEW layout -->
  </div>
</template>

<script>
import Vue from 'vue'

import UserService from '@/services/user.service'
import AgencyService from '@/services/agency.service'

import Panel from '@/components/_partial/_atomic/panel'

export default {
  name: 'ProspectView',
  components: { Panel },

  props: {
    'entity': {
      type: Object
    },
    'layout': {
      type: String
    },
    'allowEdit': {
      type: Boolean,
      default: false
    },
    'fullWidth': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      object: {},
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: UserService,
      agencyService: new AgencyService(),
      statuses: [],
      systemStatuses: [],
      groupStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        apartmentStatusMap: {},
        resetAfterMount: false,
        readonly: true
      },
      /** **/
      agencies: [],
      /** **/
      savingChanges: false,
      drawComponent: true
    }
  },

  computed: {
    standardLayout () {
      return this.layout === 'standard' || typeof this.layout === 'undefined' || this.layout === null
    },
    shortLayout () {
      return this.layout === 'short'
    },
    saleLayout () {
      return this.layout === 'sale'
    }
  },

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['user'] ? Vue.config.statusGroups['user'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired',
    'entity': 'flushObjectIfRequired'
  },

  mounted () {
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    getAgency () {
      let set = this.agencies.filter(a => { console.log(a, this.object.agency_id); return parseInt(a.id) === parseInt(this.object.agency_id) })
      if (Array.isArray(set) && set.length) {
        return set[0]
      }
      return { 'name': '' }
    },

    itemViewClick (id) {
      this.$emit('itemViewClick', id)
      return false
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'users.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                this.object[i] = result[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          })
        } else {
          if (this.entity) {
            for (let i in this.entity) {
              if (this.entity.hasOwnProperty(i)) {
                this.object[i] = this.entity[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          }
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.agencyService.getList({}, result => {
        this.agencies = []
        result.forEach((i, ind) => {
          this.agencies.push({ id: i.id, text: i.name })
        })
      })
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
              /* if (i === 'profile') {
                this.object.first_name = this.result[i].first_name
                this.object.last_name = this.result[i].last_name
              } */
            }
          }
          this.id = this.object.id
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
              /* if (i === 'profile') {
                this.object.first_name = this.newInstance[i].first_name
                this.object.last_name = this.newInstance[i].last_name
              } */
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    canBeChanged () {
      return true
      // let result = typeof this.object === 'object'
      // result = result && this.object.status === 1
      // return result
    },

    saveData () {
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), result => {
          if (this.editMode) {
            this.editMode = false
          }
          this.refresh()
          this.$emit('saved', this.object)
          this.mode.readonly = true
        })
      } else {
        this.service.create(this.prepareData(this.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[ i ] = result[ i ]
            }
          }
          this.$emit('saved', this.object)
          this.mode.readonly = true
        })
      }
    },

    prepareData (obj) {
      // let result = Object.assign({}, obj)
      // result.is_public = result.is_public ? 1 : 0
      let result = null
      if (obj.id) {
        result = {
          id: obj.id,
          first_name: obj.profile.first_name,
          last_name: obj.profile.last_name,
          email: obj.email,
          dob: obj.profile.dob,
          zip: obj.profile.zip,
          address: obj.profile.address,
          country: obj.profile.country,
          phone: obj.profile.phone,
          gender: obj.profile.gender,
          state: obj.profile.state,
          city: obj.profile.city
        }
      } else {
        result = {
          first_name: obj.first_name,
          last_name: obj.last_name,
          email: obj.email,
          dob: obj.dob,
          zip: obj.zip,
          address: obj.address,
          country: obj.country,
          phone: obj.phone,
          gender: obj.gender,
          state: obj.state,
          city: obj.city
        }
      }
      return result
    },

    /** **/

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    }

    /** action methods **/
    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>

</style>
